import { useEffect, useState } from "react";
import styled from "styled-components";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Navigation, Autoplay, Pagination]);

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000002;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .modal-section {
    background-color: white;
    border-radius: 10px;
    overflow: hidden !important;
    border: none;
    overflow-y: auto;
    width: auto;
  }

  .modal-header {
    max-width: 100%;
    padding: 15px;
    font-size: 1rem;
    font-weight: 500;
    color: black;
    display: flex;
    justify-content: space-between;
    .title-wrapper {
    }
    .btn-wrapper {
      & i {
        font-size: 1.5rem;
        color: black;
        cursor: pointer;
        :hover {
          color: #3bb77e;
        }
      }
    }
    @media (max-width: 767px) {
      padding: 10px;
    }
  }

  .modal-content {
    padding: 20px;
    border: none;
    position: relative;
    margin: 0 auto;
    width: 700px;
    height: auto;
    display: flex;
    justify-content: center;
    @media (max-width: 767px) {
      width: 100%;
    }
  }
  .swiper-wrapper {
    width: 645px !important;
    max-width: 100%;
    display: flex;
    padding-bottom: 15px;
    @media (max-width: 767px) {
      width: 100% !important;
    }
  }
  .swiper-slide {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    max-height: 638px;
    overflow-y: auto;
    width: 645px !important;
    overflow-y: auto;
    padding: 0px 50px;
    @media (max-width: 767px) {
      width: 100% !important;
      height: auto !important;
    }
  }

  .img_box {
    width: auto;
    display: flex;
    justify-content: center;
    & img {
      /* max-height: 100%; */
    }
  }

  .swiper-pagination {
    position: absolute;
    bottom: 0;
    z-index: 100000;
    display: flex;
    justify-content: center;
  }

  .swiper-pagination-bullet {
    display: flex;
    border-radius: 50%;
    margin-right: 5px;
    background-color: #ececec;
    width: 13px !important;
    height: 13px !important;
    @media (max-width: 767px) {
      width: 13px !important;
      height: 13px !important;
    }
    :last-of-type {
      margin-right: 0px;
    }
  }
`;

const SlideArrows = styled.div`
  display: flex;
  position: absolute;
  width: 100% !important;
  top: 45%;
  left: 0;
  @media (max-width: 767px) {
    top: 45%;
    & span {
      width: 30px !important;
      height: 30px !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
    & i {
      margin: 0px !important;
    }
  }
`;

const CustomizingModal = ({ modalContents, setModalContents }) => {
  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") {
      closeModal();
    }
  };

  const closeModal = () => {
    setModalContents({ ...modalContents, show: false });
  };

  return (
    <>
      <ModalWrapper>
        <div className="modal-section">
          <div className="modal-header">
            <div className="title-wrapper">{modalContents.title} 안내</div>
            <div className="btn-wrapper">
              <i className="fi-rs-circle-cross" onClick={closeModal} />
            </div>
          </div>
          <div className="modal-content">
            <Swiper
              pagination={true}
              navigation={{
                prevEl: ".custom_prev_if1",
                nextEl: ".custom_next_if1",
              }}
              slidesPerView={1}
            >
              {modalContents.image.split(",").length >= 1 &&
                modalContents.image
                  .split(",")
                  .filter((el) => el !== "")
                  .map((el, i) => (
                    <SwiperSlide key={i}>
                      <div className="img_box">
                        <img src={el} />
                      </div>
                    </SwiperSlide>
                  ))}
            </Swiper>
            {modalContents.image.split(",").length > 1 && (
              <SlideArrows className="slider-arrow slider-arrow-2">
                <span className="slider-btn slider-prev slick-arrow custom_prev_if1">
                  <i className="fi-rs-arrow-small-left"></i>
                </span>
                <span className="slider-btn slider-next slick-arrow custom_next_if1">
                  <i className="fi-rs-arrow-small-right"></i>
                </span>
              </SlideArrows>
            )}
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};
export default CustomizingModal;
